"use client";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTerms } from "@/redux/Slice/termsAndPolicy/termsAndPolicySlice";
import LegalHero from "@/components/pages/legal/LegalHero";
import LegalContent from "@/components/pages/legal/LegalContent";

export default function PrivacyPolicy() {
  const dispatch = useDispatch();
  const { privacyPolicy, status } = useSelector((state) => state.terms);

  useEffect(() => {
    if (status === "idle") {
      dispatch(getTerms());
    }
  }, [dispatch, status]);

  return (
    <>
      <LegalHero
        title="Privacy Policy"
        subtitle="We believe privacy is a right, not a feature. Here's exactly how we handle your data."
        lastUpdated="June 17, 2026"
        effective="June 17, 2026"
        version="2.1"
      />
      <div className="px-4 md:px-16 lg:px-20 py-12">
        <LegalContent
          status={status}
          html={privacyPolicy?.text}
          subject="privacy policy"
        />
      </div>
    </>
  );
}
